import api from '@/store/api/customer/product/service'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    service: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        service: state => state.service
    },
    actions: {
        showService: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showService(data)
                commit(mutationTypes.SET_SERVICE, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        enableService: async ({dispatch}, data) => {
            try {
                const response = await api.enableService(data)

                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        disableService: async ({dispatch}, data) => {
            try {
                const response = await api.disableService(data)

                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetService: async ({commit}) => commit(mutationTypes.RESET_SERVICE)
    },
    mutations: {
        [mutationTypes.SET_SERVICE]: (state, data) => state.service = data,
        [mutationTypes.RESET_SERVICE]: (state) => Object.assign(state, initialState())
    }
}
